import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent implements OnInit {

    msg:string;
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data:any){
      this.msg = data.msg;
  }

  ngOnInit(): void {
  }

}
